import { Component, Vue } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import { User } from '@/types/User'
import request from '@/helpers/request'
import imgLogoru from '@/assets/tizer-logo.png'
import imgLogoen from '@/assets/viaSteps_logo.svg'

export interface Email {
   email: string
}

@Component
export default class Restore extends Vue{

    $refs!: {
        emailForm: ElForm
    }

    public imgLogo = {
        ru: imgLogoru,
        en: imgLogoen
    }

    restoreForm: Email = {
        email: '',
    }

    successRequest: boolean = false

    loginRules: any = {
        email: [{ required: true, trigger: 'blur' }],
    }
    
    loading: boolean = false

    mounted(){
        this.loading = false
    }

    handleLogin() {
        this.$refs['emailForm'].validate(async (valid: boolean) => {
            if (!valid) return
            this.loading = true
            try {
                const response = await request({
                    url: '/users/mail_reset',
                    method: 'POST',
                    data: this.restoreForm
                })
                this.successRequest = true
            } catch (error) {
            }
            this.loading = false
        })
    }
}